import PropTypes from 'prop-types';

// material-ui
import { Box, Typography } from '@mui/material';
import { Spin } from 'antd';

// ==============================|| PROGRESS - CIRCULAR PATH ||============================== //

export default function CircularWithPath({ value, showLabel, size = 'large' }) {
	return (
		<Box sx={{ position: 'relative', display: 'inline-flex' }}>
			<Spin size={size} />
			{showLabel && (
				<Box
					sx={{
						top: 0,
						left: 0,
						bottom: 0,
						right: 0,
						position: 'absolute',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Typography variant="caption" component="div" color="text.secondary">
						{value ? `${Math.round(value)}%` : '0%'}
					</Typography>
				</Box>
			)}
		</Box>
	);
}

CircularWithPath.propTypes = {
	value: PropTypes.number,
	showLabel: PropTypes.bool,
};
